import axios from 'axios';
import {
  EmployeeMessage,
  MessageActionType,
  TaskDefinitionGroup,
  TaskDefinitionStatus
} from 'components/employee-portal/messages/types';

import {
  EMPLOYEE_MESSAGES,
  EMPLOYEE_CARD_MESSAGES,
  EMPLOYEE_MESSAGE_TASK
} from 'RestAPIs/endpoints';

export const getEmployeeMessages = (
  taskId: string,
  status: TaskDefinitionStatus,
  taskDefinitionGroup?: TaskDefinitionGroup,
  range?: string,
  isEmployeeCard?: boolean
) =>
  axios.get<EmployeeMessage[]>(
    isEmployeeCard ? EMPLOYEE_CARD_MESSAGES : EMPLOYEE_MESSAGES,
    {
      pathParams: { taskId, status },
      params: taskDefinitionGroup ? { taskDefinitionGroup } : {},
      headers: range
        ? {
            Range: range,
            'X-Range': range
          }
        : {}
    }
  );

export const updateEmployeeMessageTask = ({
  taskId,
  actionType
}: {
  taskId: string | number;
  actionType: MessageActionType;
}) =>
  axios.post(`${EMPLOYEE_MESSAGE_TASK}/${taskId}`, {
    formdata: {
      actions: actionType
    }
  });

export const updateEmployeeMessageTaskBulk = ({
  taskIds,
  actionType
}: {
  taskIds: string[] | number[];
  actionType: MessageActionType;
}) =>
  axios.put(`${EMPLOYEE_MESSAGE_TASK}/batch`, {
    taskIds: taskIds,
    formdata: {
      actions: actionType
    }
  });
